import styled from "styled-components";
import color from "constants/color";
import materialUI from "material-UI";

export const Container = styled.aside`
  width: 33.3%;
  margin-left: 32px;
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 16px;
  background: ${color.White};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const HeaderIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h2`
  font-family: Inter-Medium;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: ${color.gray900};
  margin-left: 12px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;
`;

export const IconButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #eaf2ff;
  border: 1px solid #cfe0ff;

  &.primary {
    background: ${color.primary};
    border-color: ${color.primary};
  }
`;

export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 14px 0 24px;
`;

export const SummaryCard = styled.button`
  min-height: 72px;
  border-radius: 8px;
  border: 1px solid #d7e5ff;
  background: #eaf2ff;
  cursor: pointer;
  color: ${color.primary};
  box-shadow: none;
  transition: box-shadow 0.2s, background 0.2s, border-color 0.2s, color 0.2s;

  &.danger {
    border-color: #ffd4d4;
    background: #fff0f0;
    color: #ed1c24;
  }

  &.active {
    border-color: ${color.primary};
    background: ${color.primary};
    color: ${color.White};
    box-shadow: 0px 8px 16px rgba(45, 91, 255, 0.22);
  }

  &.danger.active {
    border-color: #ed1c24;
    background: #ed1c24;
    color: ${color.White};
    box-shadow: 0px 8px 16px rgba(237, 28, 36, 0.22);
  }
`;

export const SummaryNumber = styled.strong`
  display: block;
  font-family: Inter;
  font-size: 24px;
  line-height: 29px;
  font-weight: 700;
`;

export const SummaryLabel = styled.span`
  display: block;
  margin-top: 4px;
  font-family: Inter;
  font-size: 9px;
  line-height: 13px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const ListTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
`;

export const ListTitleText = styled.h3`
  font-family: Inter-Medium;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  color: ${color.gray900};
  text-transform: uppercase;
`;

export const ResultPill = styled.span`
  border-radius: 12px;
  background: #f2f6fb;
  color: #9aa6bd;
  font-family: Inter-Medium;
  font-size: 10px;
  line-height: 12px;
  font-weight: 600;
  padding: 6px 10px;
  white-space: nowrap;
`;

export const ScrollArea = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 600px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${color.LigthGrey};
  }
`;

export const BrokerCard = styled.button`
  width: 100%;
  min-height: 76px;
  border: 1px solid #ececec;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  margin-bottom: 12px;
  text-align: left;

  &:hover {
    border-color: #cfe0ff;
  }
`;

export const SkeletonCard = styled.div`
  width: 100%;
  min-height: 76px;
  border: 1px solid #ececec;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0;
`;

export const SkeletonInfo = styled.div`
  min-width: 0;
  flex: 1;
`;

export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  overflow: hidden;
  background: #f2f6fb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const BrokerInfo = styled.div`
  min-width: 0;
  flex: 1;
`;

export const BrokerName = styled.p`
  font-family: Inter-Medium;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  color: ${color.gray900};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BrokerLeads = styled.p`
  font-family: Inter;
  font-size: 12px;
  line-height: 16px;
  color: #39516f;
`;

export const BrokerCount = styled.div`
  color: ${color.primary};
  font-family: Inter-Medium;
  text-align: right;
`;

export const CountNumber = styled.strong`
  display: block;
  font-size: 20px;
  line-height: 24px;
`;

export const CountLabel = styled.span`
  display: block;
  font-size: 9px;
  line-height: 12px;
  text-transform: uppercase;
`;

export const EmptyText = styled.p`
  font-family: Inter;
  font-size: 14px;
  color: ${color.grey9};
  margin: 40px 0;
  text-align: center;
`;

export const LoadingTasks = styled(materialUI.CircularProgress)`
  display: block;
  margin: 50px auto;
  color: ${color.primary};
  width: 25px !important;
  height: 25px !important;
`;

export const FilterContent = styled.div`
  width: 260px;
  padding: 16px;
`;

export const FilterTitle = styled.h3`
  font-family: Inter-Medium;
  font-size: 16px;
  color: ${color.gray900};
  margin-bottom: 12px;
`;

export const FilterOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter;
  font-size: 14px;
  color: ${color.gray900};
  margin-bottom: 10px;
`;

export const FilterApply = styled.button`
  width: 100%;
  height: 36px;
  border-radius: 8px;
  background: ${color.primary};
  color: ${color.White};
  font-family: Inter-Medium;
  font-size: 13px;
  cursor: pointer;
  margin-top: 8px;
`;
